var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02_\u836F\u54C1\u96F6\u552E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44,8v4H20V8H44m0-4H20a4,4,0,0,0-4,4v4a4,4,0,0,0,4,4H44a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52,24V56H12V24H52m2-4H10a2,2,0,0,0-2,2V58a2,2,0,0,0,2,2H54a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32,30a2,2,0,0,0-2,2v6H24a2,2,0,1,0,0,4h6v6a2,2,0,0,0,4,0V42h6a2,2,0,0,0,0-4H34V32a2,2,0,0,0-2-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.364cef84.svg";
export { ForwardRef as ReactComponent };